module.exports = __webpack_public_path__ + "img/Steinig.b03065be.svg";